<script lang="ts">
    import { onMount } from "svelte";
    import { GetBranchesAPI, UpdateBranchesAPI } from "../../../api/callers";
    import { Branches } from "../../../types/branches";
    import LoadingComponent from "../../loader/loader.svelte";
    let branches: Branches[] = [];
    let isLoading = true;

    onMount(() => {
        GetBranches();
    });

    async function GetBranches() {
        try {
            branches = await GetBranchesAPI();
        } catch (error) {
            console.error(error);
        } finally {
            isLoading = false;
        }
    }

    async function saveBranch() {
        try {
            isLoading = true;
            await UpdateBranchesAPI(branches);
        } catch (error) {
            console.error(error);
        } finally {
            isLoading = false;
        }
    }
</script>

<div class="branch_mapper">
    {#if isLoading}
        <LoadingComponent />
    {:else}
        <div class="branches">
            {#each branches as branch}
                <div class="branch">
                    <input type="text" bind:value={branch.branchName} />
                    <input type="text" bind:value={branch.deploymentBranch} />
                    <!-- <button class="deploy_action">Deploy</button> -->
                </div>
            {/each}
            <div class="main_action">
                <button on:click={saveBranch} class="deploy_action main"
                    >Save</button
                >
            </div>
        </div>
    {/if}
</div>

<style lang="scss">
    @import "../../../styles/vars.scss";
    .branch_mapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100% - 60px);
    }
    .deploy_action {
        background: $primary_color;
        color: white;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        &.main {
            margin-top: 30px;
            width: 200px;
            height: 40px;
        }
    }
    .main_action {
        width: 100%;
        display: flex;
        justify-content: center;
    }
</style>
